import React, { useCallback } from 'react';

import { Tag, TagSkin } from 'wix-ui-tpa/cssVars';

import { st, classes } from './TextOption.st.css';

export const TextOption: React.FC<{
  text: string;
  onClick?: (value: string) => void;
  selected?: boolean;
  disabled?: boolean;
}> = ({ text, selected, disabled, onClick }) => {
  const handleClick = useCallback(() => {
    onClick?.(text);
  }, [onClick, text]);

  return (
    <Tag
      className={st(classes.root, { selected, disabled })}
      skin={TagSkin.light}
      onClick={disabled ? undefined : onClick && handleClick}
    >
      {text}
    </Tag>
  );
};
